import { Tooltip, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class QuantidadeVistasMesa extends ReactComponent {
    getTextoVistaEmMesa() {
        let qtd = this.salaSessaoStore.quantidadeProcessosPendentesComVistaEmMesa;
        return qtd === 0 ? '' : qtd + ' Vista' + (qtd > 1 ? 's' : '') + ' em Mesa';
    }

    getTooltipVistaEmMesa() {
        let qtd = this.salaSessaoStore.quantidadeProcessosPendentesComVistaEmMesa;
        let plural = qtd > 1 ? 's' : '';
        return qtd === 0
            ? ''
            : qtd + ' Processo' + plural + ' Pendente' + plural + ' de Julgamento com Vista' + plural + ' em Mesa';
    }

    render() {
        return (
            <div>
                <Tooltip
                    title={this.getTooltipVistaEmMesa()}
                    placement="bottom"
                >
                    <Typography style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>
                        {this.getTextoVistaEmMesa()}
                    </Typography>
                </Tooltip>
            </div>
        );
    }
}

export default inject('stores')(observer(QuantidadeVistasMesa));
